// extracted by mini-css-extract-plugin
export default {"inputs-container":"Ovztum","indented":"MfhRLz"};